import React from "react";
import PortsCargoList from "components/app/tool/portsCargoList/PortsCargoList";

type ScreenPortsCargoListProps = React.PropsWithChildren<{
	match: {
		params: {
			pageNumber: string;
		};
	};
}>;

function ScreenPortsCargoList(props: ScreenPortsCargoListProps) {
	return <PortsCargoList />;
}

export default ScreenPortsCargoList;


